import { render, staticRenderFns } from "./CallAddComment.vue?vue&type=template&id=48d4ca46"
import script from "./CallAddComment.vue?vue&type=script&lang=js"
export * from "./CallAddComment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports